import React from 'react';
import { Images, ImagesTypes } from '../../assets';

interface IIconProps extends React.HTMLAttributes<HTMLElement> {
  icon: string;
  isCustom?: boolean;
  type?: keyof typeof ImagesTypes.IconTypes;
  round?: boolean;
  sharp?: boolean;
  outlined?: boolean;
  twoTone?: boolean;
  className?: string;
}

const Icon = ({
  icon,
  isCustom = false,
  type = 'icons',
  round = false,
  sharp = false,
  outlined = false,
  twoTone = false,
  className = '',
  ...props
}: IIconProps) => {
  const Svg = Images[type][icon];

  const handleMaterialIconsClass = () => {
    const variations = { round, sharp, outlined, twoTone };

    let counter = 0;
    Object.values(variations).some((variation) => {
      if (variation) {
        counter += 1;
      }

      return counter >= 2;
    });

    if (counter >= 2) {
      return 'material-icons';
    }

    const selectedVariation = Object.entries(variations).find(([_, value]) => value) || [];

    switch (selectedVariation[0]) {
      case 'round':
        return 'material-icons-round';
      case 'sharp':
        return 'material-icons-sharp';
      case 'outlined':
        return 'material-icons-outlined';
      case 'twoTone':
        return 'material-icons-two-tone';
      default:
        return 'material-icons';
    }
  };

  return isCustom ? (
    <>{Svg && <Svg className={`icon-component ${type} ${className}`.trim()} {...props} />}</>
  ) : (
    <i className={`${handleMaterialIconsClass()} ${className}`.trim()} {...props}>
      {icon}
    </i>
  );
};

export default Icon;
